import { render, staticRenderFns } from "./BasicButton.vue?vue&type=template&id=dbcb07b8&scoped=true"
import script from "./BasicButton.vue?vue&type=script&lang=js"
export * from "./BasicButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcb07b8",
  null
  
)

export default component.exports